<label class="px-3 py-2" matSnackBarLabel>
    <mat-icon class="align-middle me-2">keyboard</mat-icon>{{data.typed}}
</label>
  